import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Attribute  {
    _originalTypeClassName = "zERP.BO.Attribute";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Attribute.translate = translateService;
}
this.AttributeEnumValue = [];
this.Id = null;
this.Code = null;
this.Name = null;
this.Description = null;
this.HistoricityType = null;
this.DefinitionLevel = null;
this.DataType = null;
this.SystemEntity = null;
this.isGlobal = false;
this.IsForeign = false;
this.IsNotUsed = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
Description:any;
HistoricityType:any;
DefinitionLevel:any;
DataType:any;
SystemEntity:any;
isGlobal:any;
IsForeign:any;
IsNotUsed:any;
EntityType:any;
AttributeEnumValue:any;
clsAttributeEnumValue:any;
LinkAttribute:any;
static setEntityType = ($this, value) => {
var oldValue = $this.EntityType;
$this.EntityType = value;
if (value != null) {
if (oldValue != null) {
Domain.EntityType.removeAttributes(oldValue, $this);
}
Domain.EntityType.addAttributes(value, $this);
}
}
static setAttributeEnumValue = ($this, items) => {
                if (items == null) items = [];
                if ($this.AttributeEnumValue == null) $this.AttributeEnumValue = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AttributeEnumValue.length > 0) {
                    Domain.Attribute.removeAttributeEnumValue($this, $this.AttributeEnumValue[0]);
                }

                Domain.Attribute.addManyAttributeEnumValue($this, copyItems);
            }
static addManyAttributeEnumValue = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Attribute.addAttributeEnumValue($this, items[i]);
                }
            }
static addAttributeEnumValue = ($this, item) => {
                if ($this.AttributeEnumValue == null) $this.AttributeEnumValue = [];
                if (item == null || $this.AttributeEnumValue.indexOf(item) > -1) return;
                $this.AttributeEnumValue.push(item);
if (item.Attributes != $this) {
Domain.AttributeEnumValue.setAttributes(item, $this);
}
}
static addRangeAttributeEnumValue = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Attribute.addAttributeEnumValue($this, item));
            }
static removeAttributeEnumValue = ($this, item) => {
                if ($this == null || $this.AttributeEnumValue == null || $this.AttributeEnumValue.indexOf(item) === -1) return;
                var _index = $this.AttributeEnumValue.indexOf(item);
                $this.AttributeEnumValue.splice(_index, 1);
item.Attributes = null;
}
static clearAttributeEnumValue = ($this) => { $this.AttributeEnumValue = null; }
static setclsAttributeEnumValue = ($this, value) => {
var oldValue = $this.clsAttributeEnumValue;
$this.clsAttributeEnumValue = value;
if (value != null) {
}
}
static setLinkAttribute = ($this, value) => {
var oldValue = $this.LinkAttribute;
$this.LinkAttribute = value;
if (value != null) {
}
}

static GetClassName(): any{return "Attribute";
}
static indexDefinitionLevel(item: any): any{return ((item == Domain.DefinitionLevel.System ? "1" : ((item == Domain.DefinitionLevel.Library ? "2" : "3"))));
}
static indexHistoricityType(item: any): any{return ((item == Domain.HistoricityType.Fixed ? "1" : ((item == Domain.HistoricityType.Daily ? "2" : "3"))));
}
static parseDataType($this: any, item: any): any{if (item == "Ακέραιος") {return Domain.DataType.Integer;}else if (item == "Πραγματικός") {return Domain.DataType.Numeric;}else if (item == "Πραγματικός") {return Domain.DataType.Numeric;}else if (item == "Κείμενο") {return Domain.DataType.String;}else if (item == "Λογική") {return Domain.DataType.Logic;}else if (item == "Ημερομηνία") {return Domain.DataType.DateTime;}else if (item == "Ημέρα") {return Domain.DataType.Date;}else if (item == "Ώρα") {return Domain.DataType.Time;}else if (item == "Χρήματα") {return Domain.DataType.Money;}else if (item == "Λίστα Τιμών") {return Domain.DataType.ListValue;}else if (item == "Οντότητα") {return Domain.DataType.ListValue;}else if (item == "Διάρκεια") {return Domain.DataType.Duration;}
return Domain.DataType.Integer;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}